export const buildODataQuery = (options: {
  filter?: string;
  select?: string[];
  expand?: string;
  orderBy?: string;
  top?: number;
  skip?: number;
}) => {
  const params = new URLSearchParams();

  if (options.filter) params.append("$filter", options.filter);
  if (options.select) params.append("$select", options.select.join(","));
  if (options.expand) params.append("$expand", options.expand);
  if (options.orderBy) params.append("$orderby", options.orderBy);
  if (options.top) params.append("$top", options.top.toString());
  if (options.skip) params.append("$skip", options.skip.toString());

  return params.toString();
};
